import styled from 'styled-components'

export const GlobalTable = styled.table`
  min-height: fit-content;
  width: fit-content;
  min-width: 100%;
  text-align: start;
  border-collapse: separate;
  border-spacing: 0 0.35rem;

  tr:nth-child(2) td:first-child {
    border-top-left-radius: 0.5rem;
  }

  tr:nth-child(2) td:last-child {
    border-top-right-radius: 0.5rem;
  }

  tr:last-child td:first-child {
    border-bottom-left-radius: 0.5rem;
  }

  tr:last-child td:last-child {
    border-bottom-right-radius: 0.5rem;
  }

  tr:last-child {
    border: none;
  }
`

export const HeaderLine = styled.tr`
  position: sticky;
  top: 0;
  height: 2.2rem;
  z-index: 1;
`

export const ConfigButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  color: #bdbdbd;
  border: none;
  cursor: pointer;
  transition: background 0.2s ease;
  background: none;
  padding: 8px;
  border-radius: 6px;
  margin: 0 auto;
  line-height: 0;

  &:hover {
    background: #f5f5f5;
  }

  svg {
    width: 20px;
    height: 20px;
  }
`

export const StickyGearTh = styled.th`
  position: sticky;
  right: 0;
  z-index: 2;
  background-color: #f5f5f5;
  padding: 0;
  width: 2.5rem;
  min-width: 2.5rem;
  vertical-align: middle;
  text-align: center;
`

export const Th = styled.th`
  color: #696969;
  background-color: #f5f5f5;
  text-align: start;
  border: 0;
  font-size: 0.7rem;
  font-weight: 400;
  padding-left: 1.2rem;
  white-space: nowrap;
`

export const Tr = styled.tr`
  height: 2.4rem;
  border-bottom: solid 1px #ebebeb;
  border-radius: 1rem;
  background-color: #fff;
  &.yellowLine {
    background-color: #fffcee;
    color: #9d7d07;
    &:hover {
      background-color: rgba(229, 213, 140, 0.34);
    }
  }

  &.greenLine {
    background-color: #e8f7ec;
    color: rgba(97, 204, 122, 0.5);
    &:hover {
      background-color: #f7f7f7;
    }
  }

  &.inactiveRow {
    background-color: #f4f4f5;
    color: #71717a;
    &:hover {
      background-color: #e4e4e7;
    }
  }

  &:hover {
    background-color: #f7f7f7;

    .edit-div {
      visibility: visible;
    }
  }
`

export const FooterTr = styled.tr`
  background-color: transparent;
  border: none;
  height: auto;

  &:hover {
    background-color: transparent;
  }
`

export const Td = styled.td`
  width: 20rem;
  text-align: start;
  font-size: 12px;
  padding-left: 1.2rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 20rem;
`

export const DivInTd = styled.div`
  display: flex;
  gap: 0.3rem;
  align-items: center;

  img {
    transition: filter 0.2s ease;
  }

  &.hover-blue:hover img {
    
    filter: brightness(0.6);
  }

  &.hover-red:hover img,
  &.hover-red:hover svg {
    
    filter: brightness(1) sepia(1) saturate(20) hue-rotate(-10deg);
  }

  .documentUrl {
    cursor: pointer;
    &:hover {
      color: #0090d3;
    }
  }
`

export const TdButtons = styled.td`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  height: 2.4rem;
  width: fit-content;
  padding-right: 1rem;
`

